import { Button } from "antd";
import { useNavigate } from "react-router";
import BugIcon from "../../assets/icons/bug.svg?react";

export default function Error() {
  const navigate = useNavigate();
  return (
    <div className="flex items-center justify-center m-5 p-8 rounded-md bg-[#FFF]">
      <BugIcon />
      <div className="w-[25%] ml-[100px]">
        <p className="text-[#06709B] text-[18px]">ERROR</p>
        <p className="text-[24px] mb-2">Something went wrong</p>
        <p className="text-[#2B4752]">
          We&apos;re working to fix it. Please try again in a few minutes.
        </p>
        <Button
          onClick={() => navigate(-1)}
          variant="outlined"
          className="mt-3 w-[147px] bg-[#D2EFF9] text-[#064C68] border-[#064C68]"
        >
          Return
        </Button>
      </div>
    </div>
  );
}
